// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1IBFt","alertIcon":"ConfirmModal_alertIcon__3hos8"};